import React, { PropTypes } from 'react';
import { hashHistory } from 'react-router'
import DataService from '../lib/DataService';
import { Button, Input, message, Icon } from 'antd';

const Appid = 'wx57204c950f10923b';

const Url =  "http%3a%2f%2fda.ddycj.com%2fweb_login%23%2fwx-login"

export default class LoginPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      tel: '',
      code: '',
      count: 60,
      countState: true,
      mobileLoginVisible:false
    };
    // bind this
    this.inputToken = this.inputToken.bind(this);
    this.inputTel = this.inputTel.bind(this);
    this.getCode = this.getCode.bind(this);
    this.login = this.login.bind(this);
    this.wxLogin = this.wxLogin.bind(this);
  }

  inputTel(e) {
    this.setState({
      tel: e.target.value
    })
  }

  inputToken(e) {
    this.setState({
      code: e.target.value
    })
  }

  getCode() {
    let that = this;
    let data = {
      mobile_phone: this.state.tel
    }
    DataService.getVerificationCode(data).then((code) => {
      that.setState({
        countState: false
      });
      that.timer = setInterval(function () {
        var count = that.state.count;
        count--;
        that.setState({
          count: count
        });
        if (count < 1) {
          that.setState({
            countState: true,
            count: 60
          });
          clearInterval(that.timer);
        }
      }.bind(that), 1000);
    }).catch((error) => {
      let errorCode = error.errorMessage.errors[0].code;
      if (errorCode == 41){
        message.error("用户不存在！")
      } else if (errorCode == 21) {
        message.error("请输入正确的手机号！")
      } else if (errorCode == 42) {
        message.error("用户未激活，请到公众号激活！")
      }
    });
  }

  login() {
    if (!this.state.tel) {
      message.info('请输入手机号');
    } else if (!this.state.code) {
      message.info('请输入验证码');
    } else {
      let data = {
        mobile_phone: this.state.tel,
        token: this.state.code,
      }
      DataService.userLogin(data).then((code) => {
        clearInterval(this.timer);
        // hashHistory.push("/")
        document.location = "/web_app";
      }).catch((error) => {
        let errorCode = error.errorMessage.errors[0].code;
        if (errorCode == 41){
          message.error("手机号不存在！")
        } else if(errorCode == 31){
          message.error("验证码已失效！")
        } else if(errorCode == 32){
          message.error("验证码不正确！")
        }
      });
    }
  }

  changeLogin(){
    this.setState({
      mobileLoginVisible:true
    })
  }
  wxLogin() {
    window.location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=${Appid}&redirect_uri=${Url}&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect`;
  }
  

  render() {
    return (
      <div className="pc-login-page">
        <div className="login-mask"></div>
        <div className="login-container">
          <div className="login-logo"></div>
          <div className="login-box">
            {this.state.mobileLoginVisible&&
              <div className="submit-btn-conatiner">
                  <Input className="login-tel" placeholder="请输入手机号" onChange={this.inputTel}></Input>
                  <Input className="login-code" placeholder="请输入验证码" onChange={this.inputToken}></Input>
                  <Button ghost className="code-btn" onClick={this.getCode} disabled={!this.state.countState}>{this.state.countState ? "获取验证码" : this.state.count+' s'}</Button>
                  <Button className="login-btn" onClick={this.login}>登 录</Button>
              </div>
                        
            }
            <div className="submit-btn-conatiner">
              <Button className="login-btn wx-login" onClick={this.wxLogin}>使用微信登录</Button>
              {!this.state.mobileLoginVisible&&
              <div>
                <div className="btn-label">或</div>
                <div className="btn-label" >
                  <a onClick={this.changeLogin.bind(this)}>使用手机验证码登录</a>
                </div>
              </div>
              }


            </div>

          </div>
        </div>
        <div className="top-bar-container">
          <a className="old-login-button" href="http://www.ddycj.com/login?redirect_to_new=false">前往旧版</a>
        </div>
        <div className="bottom-bar-container">
          <div className="copyright-container">©2014-2017 杭州嘟云科技有限公司</div>
        </div>
        <div className="bottom-bar-container-2">
          <a className="beian-container" href="http://beian.miit.gov.cn">浙ICP备14030576号-1</a>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/LoginPcApp/components/LoginPage.jsx